
















import { Component, Vue } from 'vue-property-decorator';
import ArticleList from '@/components/article/ArticleList.vue';

@Component({
  components: {
    ArticleList
  }
})
export default class HomeGlobalFeed extends Vue {}
